import React, {ReactElement, ReactNode} from 'react';
import {cx} from '@emotion/css';

import DynamicLink from '@fo/components/DynamicLink/DynamicLink';

import styles from './styles';

export interface AuthorBioProps {
  authorTitle: ReactNode;
  authorRole?: string;
  shortBio?: string;
  image?: ReactNode;
  displayBorderTop?: boolean;
  linkToBio?: string;
}

function AuthorBio({
  authorTitle,
  shortBio,
  authorRole,
  image,
  displayBorderTop = true,
  linkToBio,
}: AuthorBioProps): ReactElement {
  return (
    <div className={cx(styles.container)}>
      <div className={cx(styles.profile(displayBorderTop))}>
        <div className={cx(styles.avatar, styles.column)}>{image}</div>
        <div className={cx(styles.editor, styles.column)}>
          {linkToBio ? (
            <DynamicLink href={linkToBio} className={cx('unstyledLink', styles.link)}>
              <div className={cx(styles.title)}>{authorTitle}</div>
            </DynamicLink>
          ) : (
            <div className={cx(styles.title)}>{authorTitle}</div>
          )}
          {authorRole && <p className={cx(styles.role)}>{authorRole}</p>}
          {shortBio && <p className={cx(styles.shortBio)}>{shortBio}</p>}
        </div>
      </div>
    </div>
  );
}

export default AuthorBio;
